<template>
  <div class="ukey" v-loading="loading">
    <div class="back" @click="back">
      <img src="@/assets/back.png" alt="返回" />
      返回
    </div>
    <div class="ukey_tips">
      <!-- 信息变更 -->
      <div class="ukey_error" v-if="errorCode == 4">
        <img class="ukey_error_logo" src="@/assets/change.png" alt="错误" />
        <div class="ukey_error_title">很抱歉，单位信息已变更</div>
        <div class="ukey_error_desc">
          单位信息已变更，请使用“法人一证通变更”服务或申请新的法人一证通（法人一证通变更：
          <a class="ukey_dialog_banner_link" href="https://www.962600.com/help/article/66a5d854cd5e484e95fb071c70249599">https://www.962600.com/help/article/66a5d854cd5e484e95fb071c70249599</a>
          ）；
          <br />
          您也可以在法人一证通微信小程序/法人一证通APP 中在线完成单位认证，申领法人一证通。
        </div>
      </div>
      <!-- 证书过期 -->
      <div class="ukey_error" v-else-if="errorCode == 2">
        <img class="ukey_error_logo" src="@/assets/change.png" alt="错误" />
        <div class="ukey_error_title">很抱歉，单位信息已过期</div>
        <div class="ukey_error_desc">
          单位信息已过期，请使用有效的法人一证通，或使用“法人一证通更新”服务（法人一证通更新：
          <a class="ukey_dialog_banner_link" href="https://www.962600.com/help/article/c80b06a3d0a84e299df72fcbe4ceadee">https://www.962600.com/help/article/c80b06a3d0a84e299df72fcbe4ceadee</a>
          ）；
          <br />
          您也可以在法人一证通微信小程序/法人一证通APP中在线完成单位认证，申领法人一证通。
        </div>
      </div>
      <!-- 证书撤销或者其他原因不可用 -->
      <div class="ukey_error" v-else-if="errorCode == 1 || errorCode == 5">
        <img class="ukey_error_logo" src="@/assets/change.png" alt="错误" />
        <div class="ukey_error_title">很抱歉，法人一证通{{ errorCode == 1 ? '已撤销' : '不可用' }}</div>
        <div class="ukey_error_desc">
          法人一证通{{ errorCode == 1 ? '已撤销' : '不可用' }}，请使用有效的法人一证通；
          <br />
          您也可以在法人一证通微信小程序/法人一证通APP 中在线完成单位认证，申领法人一证通。
        </div>
      </div>
      <!-- 非上海企业 -->
      <div class="ukey_error ukey_warning" v-else-if="errorCode == 3">
        <img class="ukey_error_logo" src="@/assets/warning.png" alt="提示" />
        <div class="ukey_error_title">请确认以下单位信息</div>
        <div class="ukey_error_desc">
          您正在使用当前已有所记载的信息办理新的法人一证通，该单位信息将成为新法人一证通的订户申请信息，因此请您务必确保该单位信息的准确性、完整性与有效性。如不能确保，请停止使用该单位信息，改用其他方式办理新的法人一证通。因该单位信息存在问题导致的法律后果，均由您自行承担。
        </div>
        <div class="ukey_warning_btn" v-show="!checkCertOk">
          <div class="ukey_warning_btn_submit" @click="checkCertOk = true">确认信息无误，使用该单位信息新办法人一证通</div>
          <div class="ukey_warning_btn_cancel" @click="downQrDialog = true">改用其他方式新办法人一证通</div>
        </div>
        <div class="ukey_warning_checkok" v-show="checkCertOk">
          <img src="@/assets/checkok.png" alt="对" />
          已确认单位信息
        </div>
      </div>
    </div>
    <div class="ukey_label">法人一证通</div>
    <el-divider></el-divider>
    <div class="ukey_cert">
      <div class="ukey_cert_title" :title="certInfo.corporateName">
        {{ certInfo.corporateName }}
      </div>
      <div class="ukey_cert_info">
        <div class="ukey_cert_info_label">统一社会信用代码</div>
        <div class="ukey_cert_info_desc">
          {{ certInfo.creditCode }}
          <span>法人一证通</span>
        </div>
      </div>
    </div>
    <div class="ukey_label">
      法人一证通授权
      <div class="ukey_label_link" @click="changeUrl('/auth-list')" v-show="errorCode != 1 && errorCode != 5">
        <img src="@/assets/link.png" alt="授权记录" />
        授权记录
      </div>
    </div>
    <el-divider></el-divider>
    <div class="ukey_info">
      <div class="ukey_info_title">
        <img src="@/assets/tips.png" alt="授权提示" />
        授权提示
      </div>
      <div class="ukey_info_desc">
        贵单位正在授权以下人员在本“法人一证通”平台作为贵单位的受委托人。
        <br />
        完成授权后，受委托人有权以贵单位名义在本平台办理所有事务，包括不限于：单位身份认证、法人一证通申领与使用、电子印章生成与使用、法人一证通与电子印章的授权管理、法人一证通与电子印章的管理等，且受委托人有权转授权。受委托人在平台的操作行为，均对贵单位发生法律效力。
      </div>
    </div>
    <div class="ukey_title">请填写法人一证通被授权人信息。授权后被授权人可在手机端使用</div>
    <div :class="['ukey_adduser', form.code == 0 ? '' : 'error-border']" v-for="(form, index) of userList" :key="index">
      <div class="ukey_adduser_title">法人一证通使用人</div>
      <div class="ukey_adduser_warning">
        <img v-show="form.code != 0" src="@/assets/error.png" alt="警告" />
        <span v-if="form.code == 3"> 被授权人信息核验有误 </span>
        <span v-else-if="form.code == 1"> 二要素错误 </span>
        <span v-else-if="form.code == 2"> 重复授权 </span>
        <div class="ukey_adduser_warning_del" @click="deleteUser(index)" v-show="userList.length > 1">
          <img src="@/assets/del.png" alt="删除" />
          删除
        </div>
      </div>
      <div class="ukey_adduser_form">
        <el-form label-width="258px" :rules="rules" ref="userForm" :model="form" :disabled="inoperable">
          <el-form-item label="被授权人姓名" prop="userName">
            <el-input v-model="form.userName" placeholder="请输入" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="被授权人身份证号" prop="userIdCard">
            <el-input v-model="form.userIdCard" placeholder="请输入" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="被授权人手机号" prop="userMobile">
            <el-input v-model="form.userMobile" placeholder="请输入" style="width: 200px"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="ukey_label_link" @click="addUser" v-if="!inoperable">
      <img src="@/assets/add.png" alt="添加被授权人" />
      添加被授权人
    </div>
    <div class="ukey_label_link ukey_label_unlink" v-else>
      <img src="@/assets/unAdd.png" alt="添加被授权人" />
      添加被授权人
    </div>
    <el-divider></el-divider>
    <el-tooltip class="item" :manual="true" :value="!check && checkTooltip" effect="dark" content="请阅读后勾选" placement="top">
      <el-checkbox v-model="check" :disabled="inoperable"></el-checkbox>
    </el-tooltip>
    <span class="ukey_error_desc">
      <!-- 我已阅读并同意 <a class="ukey_dialog_banner_link" href="7-B授权委托书（单位-经办)通用勾选版20220106.doc">《授权委托书》</a>
      我已阅读并同意 <a class="ukey_dialog_banner_link" href="test.pdf" target="_self">《授权委托书》</a> -->
      我已阅读并同意 <span :class="['ukey_dialog_banner_link', errorCode == 1 || errorCode == 5 ? 'disabled_text' : '']" @click="openAgreement">《授权委托书》</span>
    </span>
    <!-- <input type="radio" id="read" name="read" :value="check">
      <label for="read">我已阅读并同意 <span class="link">《授权委托书》</span></label> -->
    <div :class="['ukey_button', inoperable ? 'disabled' : '']" @click="showDialog">确认授权</div>
    <el-dialog :visible.sync="downQrDialog" width="600px">
      <template slot="title">
        <p class="success_title">您也可以在法人一证通微信小程序/法人一证通APP 中在线完成单位认证，申领法人一证通。</p>
      </template>
      <div class="success_qr">
        <!-- <div class="success_qr_item">
          <img src="@/assets/qr.png" alt="" />
          <p>IOS下载</p>
        </div>
        <div class="success_qr_item">
          <img src="@/assets/qr.png" alt="" />
          <p>IOS下载</p>
        </div>
        <div class="success_qr_item">
          <img src="@/assets/qr.png" alt="" />
          <p>IOS下载</p>
        </div> -->
        <div class="success_qr_item">
          <img src="@/assets/mp-icon.jpg" alt="" />
          <p>微信小程序 下载</p>
        </div>
      </div>
    </el-dialog>
    <AuthError ref="authError" />
    <PinError ref="pinError" />
    <Argument ref="argument" />
    <InputPin ref="inputPin" @submit="submit" />
    <InputPin ref="inputPin2" @submit="submit2" />
  </div>
</template>

<script>
import { GetRandom, SubmitGrant, VerifyCert, SubmitDZGrant } from '@/api';
import AuthError from './Dialog/auth-error.vue';
import PinError from './Dialog/pin-error.vue';
import InputPin from './Dialog/input-pin.vue';
import Argument from './Dialog/Argument.vue';
export default {
  components: {
    AuthError,
    PinError,
    InputPin,
    Argument,
  },
  data() {
    return {
      errorCode: 0, //证书错误code, 1:撤销，2：过期，3：非上海企业，4：验证证书证书信息已更改，5：其他错误导致不可用。0：正常
      loading: false,
      // verifyCertTip: false, //协卡助手验证证书不通过的
      downQrDialog: false, //使用其他方式的二维码弹窗
      checkCertOk: false, //用户确定使用该证书授权
      // errorTip: false, //头部证书错误提示
      //   showPinDialog: false, //输入密码弹窗
      //   pinErrorDialog: false, //被锁弹窗
      // warningTip: false, //头部警告提示，是否为上海企业等情况
      check: false, //是否阅读授权委托书
      checkTooltip: false, //未勾选协议的弹窗
      userList: [
        {
          userName: '',
          userMobile: '',
          userIdCard: '',
          code: 0,
        },
      ],
      rules: {
        userName: {
          required: true,
          message: '请填写被授权人姓名',
          trigger: 'blur',
        },
        userMobile: [
          {
            required: true,
            message: '请填写被授权人手机号',
            trigger: 'blur',
          },
          {
            pattern: /^[1]([3-9])[0-9]{9}$/,
            trigger: 'blur',
            message: '请填写正确的被授权人手机号',
          },
        ],
        userIdCard: [
          {
            required: true,
            message: '请填写被授权人身份证号',
            trigger: 'blur',
          },
          {
            pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/,
            trigger: 'blur',
            message: '请填写正确的被授权人身份证号',
          },
        ],
      },
      //   pin: "",
    };
  },
  computed: {
    certInfo() {
      return this.$store.state.certInfo;
    },
    inoperable() {
      return (this.errorCode !== 0 && this.errorCode !== 3) || (this.errorCode == 3 && !this.checkCertOk);
    },
    authType() {
      return this.$store.state.authType;
    },
  },
  created() {
    if (!this.certInfo.keySN && !this.certInfo.code) {
      this.$router.push('/');
    } else if (this.certInfo.keySN) {
      // this.verifyCert();
      if (this.authType == 'UKEY') {
        this.$nextTick(()=>{
          if(!sessionStorage.getItem('FRYZT_WEB_TOKEN')){
            this.$refs.inputPin2.show();
          }  
        })
      }
    }
  },
  methods: {
    showDialog() {
      if (!this.check) {
        this.checkTooltip = true;
        return;
      }
      if (this.userList.length < 1) {
        this.$message.warning('请至少添加一个授权人员');
        return;
      }
      let formComponents = this.$refs['userForm'];
      formComponents.forEach((item, index) => {
        item.validate(
          (valide) => {
            this.userList[index].code = valide ? 0 : 3;
          },
          (err) => {
            console.log(err);
            this.userList[index].code = 3;
          }
        );
      });
      let valideResult = this.userList.every((item) => item.code == 0);
      if (valideResult) {
        this.checkTooltip = false;
        if (this.authType == 'UKEY') {
          // this.pin = "";
          // this.showPinDialog = true;
          this.$refs.inputPin.show();
        } else {
          this.submitDZUser();
        }
      }
    },
    async submitDZUser() {
      try {
        this.loading = true;
        let params = {
          merchId: 1,
          grantUsers: this.userList,
          code: this.certInfo.code,
        };
        let result = await SubmitDZGrant(params);
        this.userList = result;
        let errorGrant = result.filter((item) => item.code != 0);
        if (!errorGrant.length) {
          this.$router.push('/auth-success');
        }
      } catch (error) {
        // this.$message.warning(error.message)
        this.$alert(error.message, '提示');
      } finally {
        this.loading = false;
      }
    },
    async submit2(pwd){
      try {
        this.loading = true;
        let params = {
          pwd, //PIN码
          devParam: this.certInfo.devParam, //ukey对应参数
          devType: this.certInfo.devType, //ukey对应参数
          asymid: 2, //验证RSA或者SM2
        };
        let { data } = await this.$ukJsBridge.verifyUserPin(params);
        console.log(data);
        if (data.ret == 0) {
          let { key, rnd } = await GetRandom();
          console.log(key, rnd);
          // 对rnd签名
          let signParams = {
            data: rnd, // 待签名的数据，string 类型
            pwd, // usb-key pin 码
            devParam: this.certInfo.devParam, //ukey对应参数
            devType: this.certInfo.devType, //ukey对应参数
            asymid: 2, //验证RSA或者SM2
          };
          let { data: signResult } = await this.$ukJsBridge.sign(signParams);
          console.log(signResult);
          if (signResult.ret != 0) {
            throw new Error(this.$codeToStr(signResult.ret));
          } else {
            const signature = signResult.str;
            let submitParams = {
              signature,
              sigAlg: 'SM2',
              rndKey: key,
            };
            await this.verifyCert(submitParams);
          
          }
        } else {
          let lockUkeyCode = [-2113666988, -2113601478, -4127195099];
          if (lockUkeyCode.includes(data.ret)) {
            // this.pinErrorDialog = true;
            this.$refs.pinError.show();
          } else {
            this.$message.warning(this.$codeToStr(data.ret));
          }
        }
      } catch (error) {
        // this.$message.warning(error.message);
        this.$alert(error.message, '提示');
      } finally {
        this.loading = false;
      }},
    async submit(pwd) {
      try {
        this.loading = true;
        let params = {
          pwd, //PIN码
          devParam: this.certInfo.devParam, //ukey对应参数
          devType: this.certInfo.devType, //ukey对应参数
          asymid: 2, //验证RSA或者SM2
        };
        let { data } = await this.$ukJsBridge.verifyUserPin(params);
        console.log(data);
        if (data.ret == 0) {
          let { key, rnd } = await GetRandom();
          console.log(key, rnd);
          // 对rnd签名
          let signParams = {
            data: rnd, // 待签名的数据，string 类型
            pwd, // usb-key pin 码
            devParam: this.certInfo.devParam, //ukey对应参数
            devType: this.certInfo.devType, //ukey对应参数
            asymid: 2, //验证RSA或者SM2
          };
          let { data: signResult } = await this.$ukJsBridge.sign(signParams);
          console.log(signResult);
          if (signResult.ret != 0) {
            throw new Error(this.$codeToStr(signResult.ret));
          } else {
            const signature = signResult.str;
            let submitParams = {
              orgName: this.certInfo.ownerInfo.CN,
              creditCode: this.certInfo.extInfo['1.2.156.112570.11.210'].value,
              sealData: this.certInfo.sealData, //印章结构体
              sealDataType: this.certInfo.sealDataType, //印章结构体类型
              merchId: 1, //商品ID
              signature,
              cert: this.certInfo.cert,
              sigAlg: 'SM2',
              grantUsers: this.userList,
              rndKey: key,
              sealPicData: this.certInfo.sealPicData,
              sealName: this.certInfo.ownerInfo.CN ,
              // sealName: this.certInfo.sealName,
            };
            let submitResult = await SubmitGrant(submitParams);
            console.log(submitResult);
            this.userList = submitResult;
            let errorGrant = submitResult.filter((item) => item.code != 0);
            if (!errorGrant.length) {
              this.$router.push('/auth-success');
            }
          }
        } else {
          let lockUkeyCode = [-2113666988, -2113601478, -4127195099];
          if (lockUkeyCode.includes(data.ret)) {
            // this.pinErrorDialog = true;
            this.$refs.pinError.show();
          } else {
            this.$message.warning(this.$codeToStr(data.ret));
          }
        }
      } catch (error) {
        // this.$message.warning(error.message);
        this.$alert(error.message, '提示');
      } finally {
        this.loading = false;
      }
    },
    deleteUser(index) {
      this.userList.splice(index, 1);
    },
    addUser() {
      //   const allowAddUser = this.userList.every((item) => item.disabled);
      //   if (allowAddUser) {
      this.userList.push({
        userName: '',
        userMobile: '',
        userIdCard: '',
        code: 0,
      });
      //   } else {
      //     this.$message.error("请先审核已添加的授权人！");
      //   }
    },
    changeUrl(url) {
      this.$router.push(url);
    },
    async verifyCert({ signature='',sigAlg,rndKey}={}) {
      try {
        this.loading = true;
        let creditCode = this.certInfo.extInfo['1.2.156.112570.11.210'].value;
        // // 校验证书有效性
        let { data: certChainResult } = await this.$ukJsBridge.getChain({
          asymid: 2,
          devParam: this.certInfo.devParam,
          devType: this.certInfo.devType,
        });
        if (certChainResult.ret != 0) {
          // throw new Error(this.$codeToStr(certChainResult.ret));
          this.errorCode = 5; //其他错误
          this.$alert(this.$codeToStr(verifyVertResult.ret), '提示');
          return;
        }
        this.certInfo.certChain = certChainResult.str;
        let { data: verifyVertResult } = await this.$ukJsBridge.verifyCertificate({
          asymid: 2,
          cert: this.certInfo.cert,
          cfg: 8,
          chainDevType: this.certInfo.devType,
          chainDevParam: this.certInfo.devParam,
        });
        if (verifyVertResult.ret != 0) {
          let cancelCode = [2181300321, -2113666975];
          let timeoutCode = [2181365843, -2113601453, 2181562386, -2113404910, 2181300242, -2113667054];
          if (cancelCode.includes(verifyVertResult.ret)) {
            this.errorCode = 1; //撤销
          } else if (timeoutCode.includes(verifyVertResult.ret)) {
            this.errorCode = 2; //过期
          } else {
            this.errorCode = 5; //其他错误
            this.$alert(this.$codeToStr(verifyVertResult.ret), '提示');
          }
          return;
          // throw new Error(this.$codeToStr(verifyVertResult.ret));
        }
        // 校验证书是否变更
        let params = {
          cert: this.certInfo.cert,
          orgName: this.certInfo.ownerInfo.CN,
          creditCode,
          rndKey,
          signature,
          sigAlg
        };
        let {verify,Authorization} = await VerifyCert(params);
        sessionStorage.setItem('FRYZT_WEB_TOKEN',Authorization)
        this.errorCode = verify ? 0 : 4; //证书信息更改
        // this.errorTip = !result;
        if (verify) {
          // 校验是否为上海企业证书
          const reg = /^(.{2})310/;
          this.errorCode = reg.test(creditCode) ? 0 : 3; //非上海企业
          // this.warningTip = !reg.test(creditCode);
          // console.log(this.warningTip);
        }
      } catch (error) {
        // this.$message.warning(error.message);
        // this.warningTip = true
        // this.errorTip = true
        this.errorCode = 5; //其他错误信息导致不可用
        this.$alert(error.message, '提示');
      } finally {
        this.loading = false;
      }
    },
    openAgreement() {
      if (this.errorCode == 1 || this.errorCode == 5) return;
      this.$refs.argument.show();
      // window.open('http://www.baidu.com', '_blank')
      // this.$router.push('/argument')
    },
    back() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #3340ca;
  line-height: 22px;
}
.error-border {
  border: 1px solid #ea4837 !important;
}
.disabled {
  background: #d2d2d2 !important;
}
.disabled_text {
  color: #acaeca !important;
  cursor: auto !important;
}
.ukey {
  width: 780px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
  text-align: left;
  .back {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    margin-top: 20px;
    font-size: 14px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #595959;
    line-height: 21px;
    cursor: pointer;
    img {
      width: 12px;
      height: 20px;
    }
  }
  &_error {
    width: 740px;
    // height: 142px;
    background: rgba(234, 72, 55, 0.05);
    border-radius: 2px;
    border: 1px solid rgba(234, 72, 55, 0.5);
    position: relative;
    padding: 12px 56px 16px 64px;
    margin-top: 20px;
    box-sizing: border-box;
    &_logo {
      position: absolute;
      width: 24px;
      left: 24px;
    }
    &_close {
      font-size: 10px;
      color: #555555;
      position: absolute;
      top: 14px;
      right: 16px;
      cursor: pointer;
    }
    &_title {
      font-size: 16px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #000000;
      height: 36px;
      line-height: 24px;
    }
    &_desc {
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #595959;
      line-height: 22px;
    }
  }
  &_warning {
    border: 1px solid #ffba3c;
    background: rgba(252, 242, 222, 0.5);
    &_btn {
      display: flex;
      justify-content: space-between;
      text-align: center;
      margin-top: 20px;
      &_submit,
      &_cancel {
        width: 300px;
        height: 40px;
        font-size: 14px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        line-height: 40px;
        border-radius: 2px;
        cursor: pointer;
      }
      &_submit {
        background: #ca3340;
        color: #ffffff;
      }
      &_cancel {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
      }
    }
    &_checkok {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #595959;
      line-height: 24px;
      margin-top: 29px;
      img {
        width: 20px;
        height: 14px;
      }
    }
  }
  &_label {
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    &_link {
      display: flex;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3340ca;
      cursor: pointer;
      align-items: center;
      width: 120px;
      img {
        width: 24px;
      }
    }
    &_unlink {
      color: #b2b2b2;
      cursor: auto;
    }
  }
  &_cert {
    width: 324px;
    height: 140px;
    margin: 0 auto;
    background: url(~@/assets/cert-bg.png) no-repeat top right/contain, linear-gradient(270deg, #f0d2a6 0%, #cc9d65 100%);
    border-radius: 4px;
    &_title {
      margin-bottom: 10px;
      padding: 21px 20px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 28px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &_info {
      padding: 0 20px;
      color: rgba(255, 255, 255, 0.9);
      &_label,
      &_desc {
        font-size: 13px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        // color: #FFFFFF;
        line-height: 20px;
      }
      &_desc {
        display: flex;
        justify-content: space-between;
      }
    }
  }
  &_info {
    // height: 160px;
    background: rgba(172, 174, 202, 0.1);
    padding: 17px 0;
    &_title {
      display: flex;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #4a4b57;
      line-height: 22px;
      img {
        width: 24px;
        height: 24px;
        margin-left: 7px;
      }
    }
    &_desc {
      padding: 0 17px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6a6c7d;
      line-height: 22px;
    }
  }
  &_title {
    height: 20px;
    margin: 17px 0 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #343434;
    line-height: 20px;
  }
  &_adduser {
    //   width: 740px;
    // height: 200px;
    opacity: 0.8;
    border: 1px solid rgba(172, 174, 202, 0.4);
    margin-bottom: 20px;
    &_title {
      // width: auto;
      display: inline-block;
      padding: 0 10px;
      height: 24px;
      text-align: center;
      background: #e7e8f5;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #3340ca;
      line-height: 24px;
    }
    &_warning {
      text-align: center;
      display: flex;
      align-items: center;
      margin-left: 230px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ea4837;
      line-height: 18px;
      position: relative;
      img {
        width: 16px;
        margin-right: 12px;
      }
      &_del {
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 16px;
        color: #6a6c7d;
        cursor: pointer;
        img {
          width: 20px;
          margin-right: 4px;
        }
      }
    }
    &_form {
      margin: 24px 0 27px;
    }
  }
  &_button {
    width: 96px;
    height: 40px;
    margin: 19px 0 42px;
    background: #ca3340;
    color: #fff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
  }
  &_dialog_button {
    display: inline-block;
    width: 65px;
    height: 32px;
    text-align: center;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 32px;
    cursor: pointer;
  }
  .submit {
    background: #ca3340;
    color: #ffffff;
    margin-left: 12px;
  }
  &_dialog_banner {
    width: 352px;
    margin: 0 auto;
    position: relative;
    &_icon {
      position: absolute;
      top: 0;
      left: -40px;
      color: #ea4837;
      font-size: 24px;
    }
    &_title {
      font-size: 16px;
      font-family: SourceHanSansCN-Medium, SourceHanSansCN;
      font-weight: 500;
      color: #000000;
      line-height: 24px;
      margin-bottom: 16px;
    }
    &_text {
      font-size: 14px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #6a6c7d;
      line-height: 22px;
    }
    &_link {
      color: #3340ca;
      text-decoration: none;
      cursor: pointer;
    }
  }

  //   /deep/ .el-divider--horizontal {
  //     margin: 14px 0 !important;
  //   }
  //   /deep/ .el-input__inner {
  //     width: 200px;
  //     height: 32px;
  //   }
  //   /deep/ .el-form-item {
  //     margin-bottom: 16px;
  //   }
  ::v-deep .el-checkbox__inner {
    border-radius: 7px;
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #ca3340;
    border-color: #ca3340;
  }
}

.success_title {
  width: 508px;
  height: 48px;
  font-size: 16px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  color: #000000;
  line-height: 24px;
}
.success_qr {
  display: flex;
  justify-content: space-around;
  text-align: center;
  &_item {
    img {
      width: 120px;
    }
    p {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #343434;
      line-height: 20px;
    }
  }
}
</style>
